<div class="header-nav-buttons">
    <ng-content></ng-content>
</div>
